import type { Interrupt, ResumeEntry } from '@ag-ui/client'
import type { InterruptDraft } from '../types/chat'
import { safeJson } from './json'

export function initialPayloadForInterrupt(interrupt: Interrupt): string {
  if (
    interrupt.reason === 'tool_call' ||
    interrupt.reason === 'confirmation' ||
    safeJson(interrupt.responseSchema).includes('"approved"')
  ) {
    return '{\n  "approved": true\n}'
  }

  return '{}'
}

export function createInterruptDrafts(
  interrupts: Interrupt[],
): Record<string, InterruptDraft> {
  return Object.fromEntries(
    interrupts.map((interrupt) => [
      interrupt.id,
      {
        status: 'resolved' as const,
        payloadText: initialPayloadForInterrupt(interrupt),
      },
    ]),
  )
}

export function setAllInterruptDrafts(
  current: Record<string, InterruptDraft>,
  interrupts: Interrupt[],
  draft: InterruptDraft,
): Record<string, InterruptDraft> {
  const next = { ...current }

  for (const interrupt of interrupts) {
    next[interrupt.id] = { ...draft }
  }

  return next
}

export function buildResumeEntries(
  interrupts: Interrupt[],
  drafts: Record<string, InterruptDraft>,
): ResumeEntry[] {
  return interrupts.map((interrupt) => {
    const draft = drafts[interrupt.id]
    if (!draft) throw new Error(`Missing response for ${interrupt.id}`)

    if (draft.status === 'cancelled') {
      return {
        interruptId: interrupt.id,
        status: 'cancelled' as const,
      }
    }

    return {
      interruptId: interrupt.id,
      status: 'resolved' as const,
      payload: draft.payloadText.trim()
        ? (JSON.parse(draft.payloadText) as unknown)
        : undefined,
    }
  })
}
